import { useState, FormEvent } from "react";

export default function NewsletterSection() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get("website_alt") as string;
    if (honeypot && honeypot.trim() !== "") {
      setStatus("success");
      setEmail("");
      return;
    }
    try {
      const res = await fetch("https://readdy.ai/api/form/d9qr5kfnahb7382ove0g", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ email }).toString(),
      });
      const responseText = await res.text();
      if (res.ok) {
        setStatus("success");
        setEmail("");
      } else {
        setStatus("error");
        setErrorMsg(responseText || "订阅失败，请稍后再试");
      }
    } catch {
      setStatus("error");
      setErrorMsg("网络错误，请稍后再试");
    }
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-secondary-100">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
          订阅潮流速递
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-8">
          每周获取最新日韩欧美潮流资讯、穿搭灵感和独家折扣信息
        </p>

        {status === "success" ? (
          <div className="flex items-center justify-center gap-2 text-primary-600 font-medium">
            <i className="ri-checkbox-circle-line text-lg"></i>
            <span>订阅成功！感谢你的关注</span>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form="true"
            className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          >
            <div className="honeypot-wrapper">
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
            </div>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              required
              className="w-full sm:flex-1 px-5 py-3 text-sm bg-background-50 border border-background-300 rounded-full focus:outline-none focus:border-primary-400 transition-colors"
            />
            <button
              type="submit"
              className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              立即订阅
            </button>
          </form>
        )}

        {status === "error" && (
          <p className="mt-3 text-sm text-primary-600">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}